module.exports = __webpack_public_path__ + "static/media/basketball-ball.60c9a9f7.svg";